import React from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool } from 'prop-types'

import BoostEarnings from './BoostEarnings'
import InfoAlert from './InfoAlert'
import LeaveProgramModal from './LeaveProgramModal'
import MaximizeRevenue from './MaximizeRevenue'
import { useDiscounts } from '../../../Hooks/useDiscounts'

function Discounts({ maximizeEarningsForceOptIn = false }) {
  const {
    isSaving,
    hasChanges,
    showForceOptInWarning,
    handleCancelChanges,
    handleSaveChanges,
    isLeaveModalOpen,
    handleLeaveModalClose,
    handleLeaveModalConfirm,
    ...discountsProps
  } = useDiscounts({ forceOptInEnabled: maximizeEarningsForceOptIn })

  return (
    <div>
      <InfoAlert />
      <BoostEarnings {...discountsProps} />
      <MaximizeRevenue
        {...discountsProps}
        isSaving={isSaving}
        showForceOptInWarning={showForceOptInWarning}
        forceOptInEnabled={maximizeEarningsForceOptIn}
      />

      <LeaveProgramModal
        isOpen={isLeaveModalOpen}
        isLeaving={isSaving}
        onClose={handleLeaveModalClose}
        onConfirm={handleLeaveModalConfirm}
      />

      <div className="sales-form__action-buttons-container">
        <Button
          onClick={handleSaveChanges}
          disabled={isSaving || (!hasChanges && !showForceOptInWarning)}
          size="small"
          customClass="text-sm"
        >
          Save changes
        </Button>
        <Button
          type="secondary"
          onClick={handleCancelChanges}
          disabled={isSaving}
          size="small"
          customClass="text-sm"
        >
          Cancel
        </Button>
        {hasChanges && (
          <div className="discounts__actions-warning cgt-ml-10">
            <i className="fa fa-exclamation-triangle" />
            <span className="cgt-ml-10">You have unsaved changes</span>
          </div>
        )}
      </div>
    </div>
  )
}

Discounts.propTypes = {
  maximizeEarningsForceOptIn: bool,
}

export default Discounts
